import { some } from 'lodash';

import { createCqlAdvancedSearchQuery } from '../createAdvancedSearchQuery';
import { parseMaskedAdvancedSearchQuery } from '../parseMaskedAdvancedSearchQuery';

export const transformMaskedQueryToCql = (maskedQuery: string): string => {
  const searchRows = parseMaskedAdvancedSearchQuery(maskedQuery);
  const isQueryInvalid = some(searchRows, 'isInvalid');

  if (isQueryInvalid) {
    return maskedQuery;
  }

  return createCqlAdvancedSearchQuery(searchRows);
};
